import { AutogenLayoutLMEUserDockOperations } from "./autogen/AutogenLayoutLMEUserDockOperations";
import { ChangeEvent, Label } from "@mcleod/components";
import { UserType } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";

export class LMEUserDockOperations extends AutogenLayoutLMEUserDockOperations {

    async checkboxDockSupervisorOnChange(event: ChangeEvent) {
        const row = this.sourceUserSettings.activeRow;
        if (row == null) { return; }

        if (UserType.DOCK === row.getString("web_user_type", null)
            && event.userInitiatedChange
            && event.newValue === true
        ) {
            const userString = row.getString("name") ?? row.getString("id") ?? "this user";
            CommonDialogs.showYesNo(
                new Label({
                    text: `Making ${userString} a dock supervisor will elevate their user type to an LME User. This cannot be undone.
                    \n\nYou should verify their user groups and permissions.
                    \n\nDo you wish to proceed?`
                }),
                "Confirm User Elevation").then(bool => {
                if (bool !== true) {
                    row.set("is_dock_supervisor", 'N');
                }
            });
        }
    }
}
